import pic from "./images/logo512.png";

function Webimage(){
 return <img alt="TopValidators.app" src={pic} width="48" height="48" />
}
export default Webimage

